import { useEffect, type ReactNode } from "react"
import {
  GrowthBookProvider as GBProvider,
  GrowthBook,
} from "@growthbook/growthbook-react"

const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: import.meta.env.VITE_GROWTH_BOOK_CLIENT_KEY,
  enableDevMode: import.meta.env.MODE === "development" ? true : false,
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    if (import.meta.env.MODE === "development") {
      // TODO: Use your real analytics tracking system
      // eslint-disable-next-line no-console
      console.log("Viewed Experiment", {
        experimentId: experiment.key,
        variationId: result.key,
      })
    }
  },
})

export default function GrowthBookProvider({
  children,
}: {
  children: ReactNode
}) {
  useEffect(() => {
    // Load features asynchronously when the app renders
    growthbook.loadFeatures()
  }, [])

  return <GBProvider growthbook={growthbook}>{children}</GBProvider>
}
